import React from 'react';
import merge from 'deepmerge';

var joinMessages = function joinMessages(messages) {
  if (messages.length === 0) {
    return {};
  }

  if (messages.length === 1) {
    return messages[0];
  }

  return merge.all(messages);
};

var normalizeMessages = function normalizeMessages(messages) {
  return joinMessages((Array.isArray(messages) ? messages : [messages]).filter(Boolean));
};

export default function useMessagesNormalizer(messages) {
  return React.useMemo(function () {
    return normalizeMessages(messages);
  }, [messages]);
}